import { Inter } from 'next/font/google'

export const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter',
  weight: ['400', '500', '600', '700'],
})

export const APP_CONTENT_ROOT_ID = 'app-content-root'
export const BC_PAGE_REFRESH_EVENT = 'PAGE_REFRESH'
export const BC_LOGOUT_EVENT = 'LOGOUT'
export const BC_NAME = 'tabManager'
export const DID_LOGOUT_PARAM = 'didLogoutParam'
export const X_URL_HEADER = 'x-url'
export const X_FORWARDED_FOR_HEADER = 'x-forwarded-for'
export const CF_CONNECTING_IP_HEADER = 'cf-connecting-ip'
export const TRUE_CLIENT_IP_HEADER = 'true-client-ip'
export const X_REAL_IP_HEADER = 'x-real-ip'
export const INVITES_REQUIRED_FOR_UNLOCK = 3

export const HIDE_LINKS_SECTIONS_PARAM = 'hideLinksSections'
